export class DueDateInBatchesParams {
    public dueDateStart: string;
    public dueDateFinal: string;
    public periodId: string;
    public serviceId?: string;
    public currentPage: number;
    public itemsPage: number;

    constructor() {
        this.dueDateStart = '';
        this.dueDateFinal = '';
        this.periodId = '';
        this.serviceId = null;
        this.currentPage = 1;
        this.itemsPage = 15;
    }
}
